<template>
    <div style="background-color:#fff;" >
      <mini_head_top> </mini_head_top>
      <van-row  type="flex"  justify="space-between" style="margin: auto; padding: auto; margin-top: 10px; width: 100%;text-align: left">
        <van-row>
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">办事指南</span>
        </van-row>
        <el-link style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-row >
      <div style="overflow: auto; height: calc(80vh - 40px);">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <van-cell
        v-for="item in guidList" :key="item.id" 
       @click="viewGuidOne(item.id)" >
        <template #title>
          <van-row>
            <van-col span="16"  style="overflow: hidden;  ">{{ item.theme }}</van-col>
            <van-col span="8"   style="overflow: hidden; text-overflow: ellipsis;  white-space: nowrap;">{{ item.createTime }}</van-col>
          </van-row>
          </template>
        </van-cell>
      </van-list>
    </div>
    </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import mini_head_top from "@/mini_pages/mini_head_top"
    import logo from "@/assets/image/yuanhui.png"
    import {MESSAGE_DURATION } from  '@/api/constant'
    export default {
      name : 'mini_guid_list',
      data () {
        return {
          logo,
          theme:'',
          pageNo :0,
          totalPageSize : 0,
          type : "主题",
          guidList: [],
          loading: false,
          finished: false
        }
      },
      methods: {
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        viewGuidOne(id){
          this.$router.push( {path: '/mini_view_editor', query: { id: id,fileType:'办事指南' }})
        },
        onSearch(){
          setTimeout(() => {
            this.guidListLoad(1)
          }, 200)
        },
        onLoad() {
          setTimeout(() => {
            this.guidListLoad( (this.pageNo  + 1))
          }, 200)
        },
        guidListLoad(pageNo){
          
          let url = "/bc/exa/guid/guidPage"
          let dat0 = {
            pageSize: 20,
            theme : this.theme,
            pageNo:pageNo
          }
          axios.post(url, dat0).then((response) => {
  
            this.pageNo = pageNo
            if (response.data.code === 0) {
              let dat = response.data.data
              if(dat.data.length !== 0){
                  if(pageNo == 1){
                    this.guidList = [];
                  }
                  dat.data.forEach(t=>this.guidList.push(t))
                  if( dat.data.length <dat.pageSize ){
                    this.finished = true;
                  }
              } else {
                this.finished = true
                if(pageNo == 1){
                  this.$message({
                    showClose: true,
                    message: '未查询到办事指南信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
              }
              this.loading = false;
            }else{
              this.finished = true
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
            this.loading = false;
            }).catch((err)=>{
              //this.loading = false
              this.pageNo = pageNo -1
              this.loading = false;
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            });
        },
      },
      created(){
        // setTimeout(() => {
        //     this.guidListLoad( 1)
        //   }, 200)
      },
      components :{

        mini_head_top
      }
    }
  </script>
  
  <style lang="less" scoped>
      
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_guid_list.vue